<div class="mouse-wrapper" fxHide.lt-md>
  <div class="mouse"></div>
  <p>{{ text }}</p>
</div>
